import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NotificationService } from 'src/app/core/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-download-company-list',
  imports: [ButtonModule, TooltipModule],
  templateUrl: './download-company-list.component.html',
})
export class DownloadCompanyListComponent {
  http = inject(HttpClient);
  notificationService = inject(NotificationService);
  readonly url = `${environment.apiUrl}`;
  loading = false;
  downloadList() {
    this.loading = true;
    this.http
      .get(`${this.url}/export/company-list`, {
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (!response.body) {
            console.error('Le fichier est vide ou la réponse est invalide.');
            return;
          }
          const blob = new Blob([response.body], {
            type:
              response.body.type ||
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const contentDisposition = response.headers.get(
            'Content-Disposition',
          );
          const match = contentDisposition?.match(/filename="(.+)"/);
          const fileName = match ? match[1] : 'greentripper-client-list.xlsx';
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
          this.notificationService.error('error while downloading trip list');
        },
      });
  }
}
